import { Link } from "react-router-dom";
import styled from "styled-components";
import PageTemplate from "../../../components/ui/common/template/PageTemplate";
import TitleTemplate from "../../../components/ui/common/template/TitleTemplate";
import DiamondScope from "../../../components/ui/specialty/DiamondScope";
import UseBreakpoints from "../../../components/hooks/ui/UseBreakpoints";
import VisionImage from "../../../resources/images/background/AdobeStock_258008704.jpeg";

// 근거: 에이원 제2도약 종합기획전략보고서 v3 (2026.8.27) 중 대외 공개 가능한 비전 체계만 발췌
const VisionPage = () => {
  const breakpoints = UseBreakpoints();
  return (
    <PageTemplate
      large
      image={VisionImage}
      title="비전 2033"
      aone
      phrase="관세법인을 넘어, AI 기반 글로벌 관세무역 인텔리전스 기업으로"
    >
      <p>
        2001년 창업 이후 25년, 에이원은 통관·환급·FTA·AEO·심사와 쟁송까지 관세업무의 시작과 끝을 책임져 왔습니다.
        이제 에이원은 25년간 쌓은 판단의 노하우와 데이터를 자체 AI 플랫폼에 담아, 고객의 관세·공급망 리스크를 먼저 찾아 관리하는
        제2도약을 시작합니다.
      </p>

      <Statement breakpoints={breakpoints}>
        <div>
          <span>VISION</span>
          <b>AI 기반 글로벌 관세무역 인텔리전스 기업</b>
        </div>
        <div>
          <span>MISSION</span>
          <b>세계의 모든 수출입 기업이 관세·무역 리스크로부터 자유롭게 성장하도록, 판단을 시스템화하고 신뢰를 검증 가능하게 만듭니다.</b>
        </div>
        <div>
          <span>SLOGAN</span>
          <b>국경을 넘는 모든 판단의 기준 — A1: The Standard of Trade Intelligence</b>
        </div>
      </Statement>

      <TitleTemplate
        title="핵심가치"
        noImage
        subHeader="AI가 찾고, 사람이 책임집니다."
      />
      <DiamondScope
        contents={[
          { title: "검증 가능한 신뢰", text: "모든 판단에 근거를 남깁니다" },
          { title: "선제적 예방", text: "사후 대응이 아닌 사전 진단" },
          { title: "글로벌 시야", text: "국내 1등이 아니라 기준이 되는 것" },
          { title: "전문가의 책임", text: "AI가 찾고 사람이 책임진다" },
        ]}
      />

      <TitleTemplate
        title="관세 전문가의 진화"
        noImage
        subHeader="AI는 업무 방식을 바꾸고, 경제안보는 업무영역을 넓힙니다."
      />
      <Path breakpoints={breakpoints}>
        <li>
          <b>통관 관세사</b>
          <span>정확하고 빠른 수출입 통관</span>
        </li>
        <li>
          <b>AI를 활용하는 관세 전문가</b>
          <span>AI가 처리하고, 관세사가 판단·검증·책임</span>
        </li>
        <li className="now">
          <b>공급망을 관리하는 경제안보 전문가</b>
          <span>관세·원산지·수출통제·공급망 리스크의 상시 관리</span>
        </li>
      </Path>

      <TitleTemplate
        title="3대 사업"
        noImage
        subHeader="플랫폼, 컨설팅, 글로벌 인텔리전스가 하나로 연결됩니다."
      />
      <Pillars breakpoints={breakpoints}>
        <div>
          <span>A</span>
          <b>AI 플랫폼</b>
          <p>A1 TCMS를 중심으로 품목분류·신고 자동화·리스크 점검을 구독형 서비스로 제공합니다.</p>
          <Link to="/it/ascp">ASCP 플랫폼 →</Link>
        </div>
        <div>
          <span>B</span>
          <b>전문 컨설팅</b>
          <p>관세·법률·IT를 결합해 사전진단 → 리스크 헤지 → 경영전략 자문까지 이어지는 컨설팅을 제공합니다.</p>
          <Link to="/scm">공급망관리 →</Link>
        </div>
        <div>
          <span>C</span>
          <b>글로벌 무역 인텔리전스</b>
          <p>세계 각국의 관세율·법령·수출입 제한사항을 자사 품목 기준으로 조회하고 영향을 진단하는 서비스를 준비하고 있습니다.</p>
          <Link to="/boards/briefing">오늘의 브리핑 →</Link>
        </div>
      </Pillars>

      <TitleTemplate
        title="경제안보 시대, 넓어지는 업무영역"
        noImage
        subHeader="'이 신고가 맞습니까'를 넘어 '이 공급망이 안전합니까'에 답합니다."
      />
      <Areas breakpoints={breakpoints}>
        <li>해외 경제안보 정책 조사·분석</li>
        <li>기업별 경제안보 리스크 진단</li>
        <li>원자재·부품 공급망 관리</li>
        <li>생산기지 전략 분석</li>
        <li>원산지를 넘어 '상품의 경제 국적' 관리</li>
        <li>수출통제·경제제재 대응</li>
        <li>환경·인권 등 신통상 규제 대응 (CBAM·강제노동)</li>
        <li>글로벌 생산·투자 전략 컨설팅</li>
        <li>경제안보 조기경보</li>
        <li>기업의 외부 경제안보·공급망 관리실</li>
      </Areas>
    </PageTemplate>
  );
};
export default VisionPage;

const Statement = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 62rem;
  margin: 3.5rem auto 0 auto;
  border-radius: 1.25rem;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.colors.line};
  & > div {
    display: flex;
    flex-direction: ${({ breakpoints }) => (breakpoints.md ? "row" : "column")};
    align-items: ${({ breakpoints }) => (breakpoints.md ? "center" : "flex-start")};
    gap: 1rem 1.75rem;
    padding: 1.5rem 1.75rem;
    background-color: white;
    &:not(:last-child) {
      border-bottom: 1px solid ${({ theme }) => theme.colors.line};
    }
    &:first-child {
      background: linear-gradient(135deg, ${({ theme }) => theme.colors.ink}, ${({ theme }) => theme.colors.dark});
      & > span {
        border-color: ${({ theme }) => theme.colors.foreground.highlightinverted};
        color: ${({ theme }) => theme.colors.foreground.highlightinverted};
      }
      & > b {
        color: white;
        font-size: 1.35rem;
      }
    }
    & > span {
      min-width: 7.5rem;
      font-size: 0.8rem;
      font-weight: 800;
      letter-spacing: 0.14em;
      color: ${({ theme }) => theme.colors.accent};
      border: 1px solid ${({ theme }) => theme.colors.accent};
      border-radius: 999px;
      padding: 0.4rem 1rem;
      text-align: center;
      box-sizing: border-box;
    }
    & > b {
      font-size: 1.15rem;
      line-height: 1.6;
      color: ${({ theme }) => theme.colors.dark};
    }
  }
`;
const Path = styled.ol`
  list-style: none;
  margin: 0 auto;
  padding: 0;
  max-width: 65rem;
  display: flex;
  flex-direction: ${({ breakpoints }) => (breakpoints.md ? "row" : "column")};
  gap: 0.75rem;
  & > li {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    padding: 1.5rem;
    border-radius: ${({ theme }) => theme.radius};
    background-color: ${({ theme }) => theme.colors.monotone.extralight};
    & > b {
      font-size: 1.15rem;
      color: ${({ theme }) => theme.colors.dark};
    }
    & > span {
      color: ${({ theme }) => theme.colors.foreground.dimmed};
    }
    &.now {
      background: linear-gradient(135deg, ${({ theme }) => theme.colors.ink}, ${({ theme }) => theme.colors.dark});
      & > b {
        color: white;
      }
      & > span {
        color: rgba(255, 255, 255, 0.75);
      }
    }
  }
`;
const Pillars = styled.div`
  display: grid;
  grid-template-columns: ${({ breakpoints }) => (breakpoints.lg ? "repeat(3, minmax(0, 1fr))" : "minmax(0, 1fr)")};
  gap: 1rem;
  & > div {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
    padding: 1.75rem;
    border-radius: 1.25rem;
    border: 1px solid ${({ theme }) => theme.colors.line};
    background-color: white;
    transition: box-shadow 0.2s, transform 0.2s;
    &:hover {
      box-shadow: ${({ theme }) => theme.shadow.md};
      transform: translateY(-3px);
    }
    & > span {
      width: 2.75rem;
      height: 2.75rem;
      border-radius: 0.75rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.25rem;
      font-weight: 800;
      color: white;
      background: linear-gradient(135deg, ${({ theme }) => theme.colors.accent}, ${({ theme }) => theme.colors.dark});
    }
    & > b {
      font-size: 1.3rem;
      color: ${({ theme }) => theme.colors.dark};
    }
    & > p {
      flex: 1;
      margin: 0;
      line-height: 1.7;
      color: ${({ theme }) => theme.colors.monotone.dark};
    }
    & > a {
      font-weight: 700;
      color: ${({ theme }) => theme.colors.accent};
    }
  }
`;
const Areas = styled.ol`
  margin: 0 auto;
  max-width: 62rem;
  display: grid;
  grid-template-columns: ${({ breakpoints }) => (breakpoints.md ? "repeat(2, minmax(0, 1fr))" : "minmax(0, 1fr)")};
  gap: 0 2.5rem;
  padding: 0;
  list-style: none;
  counter-reset: area;
  & > li {
    counter-increment: area;
    display: flex;
    align-items: center;
    gap: 0.9rem;
    font-size: 1.05rem;
    padding: 0.95rem 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.line};
    color: ${({ theme }) => theme.colors.monotone.dark};
    &:before {
      content: counter(area, decimal-leading-zero);
      flex: 0 0 auto;
      font-size: 0.85rem;
      font-weight: 800;
      color: ${({ theme }) => theme.colors.accent};
    }
  }
`;
